import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
export const loginStep = {
  PHONE: 'PHONE',
  OTP: 'OTP',
  ID: 'ID',
  CODE: 'CODE',
  SELECTLOBBY: 'SELECTLOBBY',
  SELECTPRIVATE: 'SELECTPRIVATE',
  ERROR: 'ERROR',
  GENERALERROR: 'GENERALERROR',
  TERMS: 'TERMS',
  DIGITS: 'DIGITS',
  PAYPAL_EMAIL: 'PAYPAL_EMAIL',
  TALKMANERROR: 'TALKMANERROR',
  NOPRIMARYERROR: 'NOPRIMARYERROR',
};

export const lobbySelection = {
  BUSINESS: 'BUSINESS_WEBSITE',
  PRIVATE: 'PRIVATE_WEBSITE',
};
export const rolesLogin = {
  OTPSUBSCRIBER_CONTACTPRIVATE: 'OTPSUBSCRIBER_CONTACTPRIVATE',
  OTPSUBSCRIBER_CONTACTBUSINESS: 'OTPSUBSCRIBER_CONTACTBUSINESS',
  OTPSUBSCRIBER_SUBSCRIBER: 'OTPSUBSCRIBER_SUBSCRIBER',

  OTPEXTENDED_CONTACTPRIVATE: 'OTPEXTENDED_CONTACTPRIVATE',
  OTPEXTENDED_CONTACTBUSINESS: 'OTPEXTENDED_CONTACTBUSINESS',
  OTPEXTENDED_SUBSCRIBER: 'OTPEXTENDED_SUBSCRIBER',

  OTPCUSTOMER_CONTACTPRIVATE: 'OTPCUSTOMER_CONTACTPRIVATE',
  OTPCUSTOMER_CONTACTBUSINESS: 'OTPCUSTOMER_CONTACTBUSINESS',
  OTPCUSTOMER_SUBSCRIBER: 'OTPCUSTOMER_SUBSCRIBER',

  NEWOTP_CONTACTPRIVATE: 'NEWOTP_CONTACTPRIVATE',
  NEWOTP_CONTACTBUSINESS: 'NEWOTP_CONTACTBUSINESS',
  NEWOTP_SUBSCRIBER: 'NEWOTP_SUBSCRIBER',

  NEWCREDENTIALS_CONTACTPRIVATE: 'NEWCREDENTIALS_CONTACTPRIVATE',
  NEWCREDENTIALS_CONTACTBUSINESS: 'NEWCREDENTIALS_CONTACTBUSINESS',
  NEWCREDENTIALS_SUBSCRIBER: 'NEWCREDENTIALS_SUBSCRIBER',
};

export const rolesKeys = {
  BUSINESS: 'CONTACTBUSINESS',
  PRIVATE: 'CONTACTPRIVATE',
  OTHERPRIVATE: 'CONTACTPRIVATEANOTHERID',
  SUBSCRIBER: '_SUBSCRIBER',
  OTPSUBSCRIBER: 'OTPSUBSCRIBER',
  OTPEXTENDED: 'OTPEXTENDED',
  OTPCUSTOMER: 'OTPCUSTOMER',
  NEWOTP: 'NEWOTP',
  NEWCREDENTIALS: 'NEWCREDENTIALS',
  CREDENTIALS: 'CREDENTIALS',
  IDFOTP: 'IDFOTP',
  OTP: 'OTP',
  SILENTLOGINOTP: 'SILENTLOGINOTP',
  SILENTOTP: 'SILENTOTP',
  SILENTLOGINBAN: 'SILENTLOGINBAN',
  SILENTLOGINCREDENTIALS: 'SILENTLOGINCREDENTIALS',
  COMPLETEREGISTRATION : 'COMPLETEREGISTRATION',
  
};

export const fullLoginRoles =
 [rolesKeys.OTPCUSTOMER, rolesKeys.CREDENTIALS, rolesKeys.NEWCREDENTIALS, rolesKeys.IDFOTP,
  rolesKeys.SILENTLOGINBAN,rolesKeys.SILENTLOGINCREDENTIALS, rolesKeys.COMPLETEREGISTRATION
 ];
export const otpLoginRoles = [rolesKeys.OTPSUBSCRIBER, rolesKeys.OTP, 
   rolesKeys.NEWOTP ,rolesKeys.SILENTLOGINOTP ,rolesKeys.SILENTOTP ];
export const otpExtendedLoginRoles = [rolesKeys.OTPEXTENDED];


export const otpOrigin = {
  GENERIC: 'cellular vas OTP',
  LOGIN: 'main OTP',
  ABROAD: 'abroad OTP',
  POPUP: 'popup OTP',
  ECOMMERCE: 'ecommerce OTP',
};

export const originProcess = {
  LOBBY: 'abroad lobby',
  TICKET: 'checkout page',
};

export const OrgEmployeeLoginTypes = [
   'ORGANIZATIONEMPLOYEEFAMILY',
  'ORGANIZATIONEMPLOYEECREDENTIALS'
];

export const isOrgEmployeeLogin = (authentication) => {
  const role = authentication?.loginData?.userDetails?.RoleList?.[0];
  if(isNullOrEmpty(role)){
    return false;
  }
  return OrgEmployeeLoginTypes.includes(role);
};